import CrudTable from "../core/component/crud/CrudTable";
import {
  getUserCPColumns,
  getUserCPFormItems,
} from "../components/crud/UserCPComponents";
import { otherApi, userCrudApi } from "../core/client/BaseEntityApi";
import { useEffect, useState } from "react";
import { userCrudExtendedApi } from "../client/EntityApi";

const UserCrudPage = () => {
  const [roles, setRoles] = useState([]);
  const [visibilities, setVisibilities] = useState([]);

  useEffect(() => {
    otherApi
      .constants()
      .then((response) => setVisibilities(response["visibilities"]));
    userCrudExtendedApi.getAllRoles().then((response) => {
      const mappedRoles = response["hydra:member"].map((role: any) => {
        return { label: role.name, value: role["@id"] };
      });
      setRoles(mappedRoles);
    });
  }, []);

  return (
    <CrudTable
      api={userCrudApi}
      entityLabel="Kullanıcı"
      searchKeys={["name", "surname"]}
      columns={getUserCPColumns()}
      addFormItems={getUserCPFormItems(roles, visibilities, true)}
      editFormItems={getUserCPFormItems(roles, visibilities)}
      setEditFields={(row) => {
        return {
          ...row,
          role: row.role["@id"],
        };
      }}
      beforeEditOperation={(values) => {
        if (values.plainPassword === "") values.plainPassword = undefined;
        return values;
      }}
    />
  );
};

export default UserCrudPage;
